<template>
  <div class="content">
    <div
      class="containerExport mt40"
      v-if="!loading"
      @click.self="
        isModalPaiementVisible = false;
        isModalConnectVisible = false;
        isModalImportVisible = false;
      "
    >
      <table class="recapInformation">
        <tr>
          <td class="title green">
            {{ formatMoney(document.amount) }} {{ document.locale_currency }}
          </td>
        </tr>
        <tr>
          <td class="title black">
            {{
              $t("export." + document_type, {
                organization: document.organization_name,
              })
            }}
          </td>
        </tr>
        <tr
          v-if="
            isPaymentActionEnabled &&
            ['pending', 'not paid'].includes(document.status.toLowerCase()) &&
            parseInt(document.amount) > 0
          "
        >
          <td style="padding-top: 9px">
            <span class="pd710 bgGrey greyLight radius5 fw500 ls">
              {{ $t("export.to_pay_before") }}
              {{ transformDate(document.payment_deadline_at) }}
            </span>
          </td>
        </tr>
      </table>

      <div class="containerButton mt30">
        <div
          v-if="
            isPaymentActionEnabled &&
            ['pending', 'not paid'].includes(document.status.toLowerCase()) &&
            parseInt(document.amount) > 0
          "
        >
          <div class="bank-button">
            <div
              @click="showModalPaiement"
              class="containerButtonInfo bgWhite radius5 txtButton"
              style="box-shadow: 0px 5px 8px 0px rgba(126, 128, 131, 0.11)"
            >
              <div
                v-if="bank_details && client_id == null"
                class="black ph20 pv7 fw500 ls"
              >
                {{ $t("export.pay_by_bank_transfer") }}
              </div>

              <div
                v-if="client_id && bank_details == null"
                class="black ph20 pv7 fw500 ls"
              >
                {{ $t("export.pay_by_card") }}
              </div>

              <div
                v-if="client_id && bank_details"
                class="black ph20 pv7 fw500 ls"
              >
                {{ $t("export.pay_by_card_or_bank") }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="supplier_app_id != appId" class="import-button">
          <span
            id="ou"
            class="pd20H pd10Top black fw300"
            v-if="
              isPaymentActionEnabled &&
              ['pending', 'not paid'].includes(document.status.toLowerCase()) &&
              parseInt(document.amount) > 0
            "
          >
            {{ $t("export.and") }}
          </span>

          <div
            v-if="bearer != null && bearer.length > 0"
            style="padding-bottom: 40px"
          >
            <div
              class="bgGreen ph20 pv7 radius5 txtButton fw500 ls"
              style="
                /* box-shadow: 0px 4px 10px 0px rgba(46, 212, 122, 0.16); */
                cursor: pointer;
              "
              v-on:click="showModalConnect()"
            >
              {{ $t("export.import_in", { name }) }}
            </div>
          </div>

          <div
            v-else
            id="importButton"
            class="containerButtonInfo"
            @mouseenter="showDropdown"
            @mouseleave="startHideTimer"
          >
            <div
              class="bgGreen ph20 pv7 radius5 txtButton fw500 ls"
              style="
                /* box-shadow: 0px 4px 10px 0px rgba(46, 212, 122, 0.16) */
                cursor: pointer;
              "
            >
              {{ $t("export.import_accounting") }}
            </div>
          </div>

          <div
            v-show="isDropdownVisible"
            class="dropDownBanner"
            :class="{
              // cardCenterButton: domain !== 'sinao.app',
              alignLeft: isPaymentActionEnabled === false,
              cardCenter: isPaymentActionEnabled === true && accounting_marking,
              alignCenter:
                isPaymentActionEnabled === true && !accounting_marking,
            }"
            @mouseenter="cancelHideTimer"
            @mouseleave="hideDropdown"
          >
            <div
              v-if="bearer == null || bearer.length == 0"
              class="card bgWhite"
            >
              <div class="cardHeader">
                <h1 class="cardTitle black">{{ $t("export.fec_file") }}</h1>
              </div>

              <div>
                <span class="black">
                  {{ $t("export.fec_file_desc") }}
                </span>
              </div>

              <div>
                <div
                  class="cardButton button bgBlue txtButton"
                  style="margin-top: 48px"
                  @click="downloadFecDocument"
                >
                  <span class="white fw600">{{
                    $t("export.download_fec")
                  }}</span>
                </div>
              </div>
            </div>

            <div v-if="accounting_marking" class="card bgGreen">
              <div class="cardHeader">
                <img class="cardLogo" :src="whitelabel_logo" alt="" />
                <!-- <span class="white pd3Left"> connect </span> -->
                <span class="link pd3Left white">Link</span>
              </div>

              <div>
                <h2 class="titleModal white" style="margin-top: 20px">
                  {{ $t("export.automate_accounting") }}
                </h2>
                <div
                  class="fw300"
                  style="color: #f5f6f8; padding-top: 10px; font-size: 13px"
                  v-html="
                    $t('export.automate_accounting_desc', {
                      name,
                    })
                  "
                />
              </div>

              <div>
                <!-- style="max-width: 220px" -->
                <div
                  class="cardButton button bgWhite txtButton"
                  style="width: fit-content"
                >
                  <span class="green" style="font-weight: 600; font-size: 13px">
                    <a
                      v-if="bearer == null || bearer.length == 0"
                      class="redirectButton green"
                      :href="
                        domain === 'sinao.app'
                          ? 'https://www.sinao.fr/fonctionnalites/gestion-des-depenses'
                          : webflow ?? ''
                      "
                      :target="domain == 'sinao.app' || webflow ? '_blank' : ''"
                    >
                      {{ $t("export.discover", { name }) }}
                    </a>
                  </span>
                </div>
                <div
                  v-if="bearer.length == 0"
                  v-on:click="showModalConnect()"
                  class="fw300"
                  style="
                    color: #f5f6f8;
                    padding-top: 7px;
                    font-size: 13px;
                    cursor: pointer;
                  "
                >
                  {{ $t("export.already_account") }}
                  <b style="font-weight: 500">{{ $t("export.login") }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="containerDocument">
        <div class="containerDownload" @click="downloadDocument">
          <i class="fas fa-save"></i>
          <span class="black pf10 fw600">{{
            $t("export.download_invoice_pdf")
          }}</span>
        </div>

        <img :src="'data:image/png;base64,' + document.preview" />
      </div>

      <ModalPaiement
        v-show="isModalPaiementVisible"
        @close="closeModalPaiement"
        @keydown.esc="closeModalPaiement"
        :bank_details="bank_details"
        :document="document"
        :client_id="client_id"
        :token="token"
      />

      <ModalConnect
        v-show="isModalConnectVisible"
        @close="closeModalConnect"
        @keydown.esc="closeModalConnect"
        :document="document"
      />
    </div>
  </div>
</template>

<script>
import ModalConnect from "../components/Modals/ModalConnect.vue";
import ModalPaiement from "../components/Modals/ModalPaiement.vue";
import logoWhite from "../assets/logo-white.svg";

import { mapState } from "vuex";
import axios from "axios";
import Vue from "vue";
// import { query } from "sinao-corejs";

export default {
  name: "Export_document",
  props: {
    response: Object,
  },
  data() {
    return {
      loading: true,
      url: "https://api.sinao.app/v1",
      token: "",
      bank_details: {},
      document: {},
      client_id: "",
      supplier_app_id: null,
      document_type: "",
      isModalPaiementVisible: false,
      isModalImportVisible: false,
      isModalConnectVisible: false,
      isPaymentActionEnabled: false,
      whitelabel_logo: null,
      isDropdownVisible: false,
      hideTimer: null,
    };
  },
  components: {
    ModalConnect,
    ModalPaiement,
  },
  filters: {
    decodeBase64(value) {
      return atob(value);
    },
  },
  watch: {
    selected_document: {
      handler(newVal) {
        if (newVal == null) return;

        this.document = newVal;
        this.isPaymentActionEnabled = newVal.is_payment_action_enabled;
        this.bank_details = newVal.bank_details;
      },
      deep: true,
      immediate: true,
    },
    response: {
      handler(newResponse) {
        if (newResponse && Object.keys(newResponse).length > 0) {
          this.updateDataFromResponse(newResponse);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState([
      "appId",
      "bearer",
      "selected_document",
      "domain",
      "name",
      "accounting_marking",
      "webflow",
      "logo",
    ]),
  },
  async created() {
    this.loading = true;

    const cookieArray = document.cookie.split("; ");
    for (const cookie of cookieArray) {
      const [name, value] = cookie.split("=");
      if (name === "token" || name === "ken") {
        await this.$store.dispatch("setBearer", { bearer: value });
        break;
      }
    }

    this.url =
      window.location.hostname === "localhost"
        ? "https://api.sinao.test/v1"
        : "https://api.sinao.app/v1";

    const urlParams = new URLSearchParams(window.location.search);
    this.isModalConnectVisible = urlParams.get("supplier_relation")
      ? true
      : false;
    const supplierToken = urlParams.get("token");
    console.log("supplierToken DOC ", supplierToken);
    if (supplierToken?.length > 0) {
      this.$store.dispatch("setSupplierToken", { token: supplierToken });
    } else {
      window.location.href = this.webflow ?? "https://sinao.fr";
    }

    this.updateDataFromResponse(this.response);

    if (this.isModalConnectVisible) {
      this.showModalConnect();
    }
  },
  methods: {
    updateDataFromResponse(response) {
      this.$store.dispatch("setNationalId", {
        nationalId: response.client_national_id,
      });

      this.$store.dispatch("setDocuments", {
        documents: response.documents,
      });

      this.$store.dispatch("setSelectedDocumentId", {
        selected_document_id: response.document_selected,
      });

      this.$store.dispatch("setSelectedDocument", {
        selected_document: response.documents.find(
          (document) => document.id == response.document_selected
        ),
      });

      this.supplier_app_id = response.supplier_app_id;
      document.title =
        "Vos factures de " +
        response.document.organization_name +
        " | " +
        this.name +
        " Link";
      this.document = response.document;
      this.$store.dispatch("setDocument", { document: response.document });
      this.$store.dispatch("setEmails", { emails: response.emails });
      this.client_id = response.client_id;
      this.document_type = response.document_type;
      this.whitelabel_logo =
        this.domain === "sinao.app" ? logoWhite : this.logo;

      this.loading = false;
    },
    transformDate(stringDate) {
      let newDate = new Date(stringDate);

      let day =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();

      let mounth =
        newDate.getMonth() + 1 < 10
          ? "0" + (newDate.getMonth() + 1)
          : newDate.getMonth() + 1;

      return day + "/" + mounth + "/" + newDate.getFullYear();
    },
    showModalPaiement() {
      if (
        this.document.amount > 0 &&
        (this.bank_details.name != null || this.client_id != "")
      ) {
        this.isModalPaiementVisible = true;
      } else {
        if (this.document.amount > 0) {
          Vue.$toast.open({
            message: this.$t("export.cannot_pay_zero"),
            type: "error",
          });
        } else {
          Vue.$toast.open({
            message: this.$t("export.cannot_pay_no_bank"),
            type: "error",
          });
        }
      }
    },
    closeModalPaiement() {
      if (this.isModalPaiementVisible) {
        this.isModalPaiementVisible = false;
      }
    },
    showModalImport() {
      this.isModalImportVisible = true;
    },
    closeModalImport() {
      this.isModalImportVisible = false;
    },
    async downloadDocument() {
      var token = this.document.token;
      if (this.document.number == null && token == null) {
        token = this.token;
      }

      const a = document.createElement("a");
      const hrefUrl = `${this.url}/invoice/download/pdf/${token}`;
      a.href = hrefUrl;
      a.setAttribute("download", `${this.document.id}.pdf`);
      a.click();
    },
    async downloadFecDocument() {
      // const token = this.token;
      const token = this.document.token;
      axios
        .get(`${this.url}/invoice/download/fec/${token}`, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "invoice.zip");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async showModalConnect() {
      this.isModalConnectVisible = true;
    },
    closeModalConnect() {
      if (this.isModalConnectVisible) {
        this.isModalConnectVisible = false;
      }
    },
    showDropdown() {
      this.cancelHideTimer();
      this.isDropdownVisible = true;
    },
    startHideTimer() {
      // Petit délai avant de cacher pour laisser le temps d'atteindre le dropdown
      this.hideTimer = setTimeout(() => {
        this.hideDropdown();
      }, 200);
    },
    cancelHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    },
    hideDropdown() {
      this.isDropdownVisible = false;
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 2,
      }).format(amount);
    },
  },
};
</script>

<style>
.content {
  width: 100%;
  height: calc(100vh - 40px);
  overflow-y: auto;
  padding-bottom: 40px;

  border-radius: 0 10px 0 0;
  background-color: #f5f6f8;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 999;
  transform: none;
  height: fit-content !important;
}

.containerExport {
  width: 100%;
  height: 100%;
  padding-left: 25%;
  padding-right: 25%;
  margin: auto;
  overflow-y: auto;
}

.title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 109.02%;
}

.txtButton {
  font-size: 13px;
  font-weight: 400; /* SEMI-BOLD */
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.link {
  text-decoration: none;
}

.link:link,
.link:visited {
  color: var(--link);
}

.containerButton {
  display: flex;
  justify-content: left;
  width: fit-content;

  position: relative;
}

.import-button {
  position: relative;
}

.containerButtonInfo {
  text-align: center;
  cursor: pointer;
}

.containerDownload {
  display: flex;
  align-content: center;
  justify-content: end;
  margin-bottom: 10px;
  cursor: pointer;
  width: fit-content;
  margin-left: auto;
}

.containerDocument img {
  width: 100%;
  margin: auto;
}

.dropDownBanner {
  position: absolute;
  top: calc(100% - 30px);
  right: auto;
  border-radius: 5px;
  display: flex;
  box-shadow: 0px 2px 2px rgba(50, 45, 40, 0.1),
    0px 6px 15px rgba(54, 47, 40, 0.25);
}

.card {
  padding: 25px 40px;
}

.card {
  width: 280px;
}

.card + .bgGreen {
  width: 390px !important;
  max-width: 100%;
}

.card:first-child {
  border-radius: 5px 0 0 5px;
}
.card:last-child {
  border-radius: 0 5px 5px 0;
}
.alignCenter > .card:last-child {
  border-radius: 5px !important;
}

.ph20 {
  padding-left: 20px;
  padding-right: 20px;
}

.pv7 {
  padding-top: 7px;
  padding-bottom: 7px;
}

.cardHeader {
  display: flex;
  justify-content: left;
  align-items: end;
  margin-bottom: 20px;
}

.cardTitle {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  font-style: normal;
  letter-spacing: 0.01em;
  margin: 0px;
}

.cardLogo {
  /* width: 73px; */
  /* height: 24px; */
  width: fit-content;
  height: 18px;
}

.cardButton {
  margin-top: 20px;
  /* width: calc(100% - 30px); */
  width: 100%;
  height: 32px;
  border-radius: 5px;
  text-decoration: none;
}

.infoButton {
  max-width: 180px;
  display: block;
  padding-top: 5px;
}

.ls {
  letter-spacing: 0.13px;
}

.cardCenter {
  right: calc(-196px * 1.5);
}

.cardCenterButton {
  right: calc(-196px / 4) !important;
}
.cardCenterButton .card {
  border-radius: 5px !important;
}

.alignLeft {
  left: calc(-170px / 2) !important;
  right: auto !important;
}

.alignCenter {
  left: calc(-80px / 2) !important; /* padding for centering - 40px each side */
  right: auto !important;
}

@media screen and (max-width: 1800px) {
  .containerExport {
    width: 100%;
    padding-left: 15%;
    padding-right: 15%;
  }
}

@media screen and (max-width: 1100px) {
  .dropDownBanner {
    left: 0;
    right: auto !important;
  }
}

@media screen and (max-width: 1000px) {
  .dropDownBanner {
    left: 0;
    right: auto !important;
  }
}

@media screen and (max-width: 910px) {
  .dropDownBanner {
    flex-wrap: wrap-reverse;
    left: 0 !important;
    right: auto !important;
    width: 350px !important;
  }

  .alignLeft {
    flex-wrap: wrap-reverse;
    max-width: 350px;
    left: 0 !important;
    right: auto !important;
  }

  .alignCenter,
  .cardCenter {
    left: 0 !important;
    right: auto !important;
  }

  .alignLeft .card,
  .dropDownBanner .card {
    width: 100% !important;
    max-width: 350px;
  }

  .alignLeft .card:first-child,
  .dropDownBanner .card:first-child {
    border-radius: 0px 0px 5px 5px !important;
  }

  .alignLeft .card:last-child,
  .dropDownBanner .card:last-child {
    border-radius: 5px 5px 0px 0px !important;
  }

  .alignCenter .card,
  .dropDownBanner .card {
    width: 100% !important;
    max-width: 350px;
  }
}

@media screen and (max-width: 800px) {
  .containerButton {
    position: initial;
  }

  .dropDownBanner {
    left: 0 !important;
    right: auto !important;
    width: 350px !important;
  }

  .alignLeft {
    left: 0 !important;
    right: auto !important;
  }

  .alignCenter,
  .cardCenter {
    left: 0 !important;
    right: auto !important;
  }

  .card {
    text-align: left !important;
  }
}

/* @media screen and (max-width: 700px) {
  .cardCenter {
    left: calc((100% - 520px) / 2) !important;
    right: auto !important;
    top: 28vh !important;
    width: 350px !important;
  }
} */

/* -- Mobile --*/
@media screen and (max-width: 630px) {
  .recapInformation {
    margin: auto;
  }

  .recapInformation > tr {
    text-align: center;
  }

  .containerExport {
    width: 100%;
    padding-left: 5%;
    padding-right: 5%;
  }

  .containerButton {
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
  }

  .cardCenter {
    width: 350px !important;
  }

  .alignLeft {
    left: 0 !important;
    right: auto !important;
  }

  .alignCenter,
  .cardCenter {
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%);
  }
}

@media screen and (max-width: 600px) {
  .card:first-child {
    border-radius: 5px 5px 0px 0px !important;
  }

  .card:last-child {
    border-radius: 0px 0px 5px 5px !important;
  }

  .dropDownBanner {
    /* right: 10px; */
    /* width: 280px; */
  }

  .cardButton {
    margin-top: 20px !important;
  }

  .card {
    padding: 26px 30px;
  }

  span.black.pf10:nth-child(1) {
    display: none;
  }

  .alignLeft {
    left: 0 !important;
    right: auto !important;
  }
}

@media screen and (max-width: 592px) {
  .dropDownBanner {
    /* top: 32vh; */
  }
}

@media screen and (max-width: 500px) {
  .dropDownBanner {
    /* top: 32vh; */
    /* right: 10px; */
    width: 280px !important;
    left: 0 !important;
    right: auto !important;
  }

  .cardCenter {
    left: 0 !important;
    right: auto !important;
  }

  .alignLeft {
    left: 0 !important;
    right: auto !important;
  }
}

@media screen and (max-width: 430px) {
  .title {
    font-size: 22px;
  }

  .containerButton {
    display: grid;
  }

  .containerButton:nth-child(2) {
    margin-bottom: 0px !important;
  }

  #ou {
    display: none;
  }

  .containerButtonInfo {
    margin-bottom: 20px;
  }

  .mb40 {
    margin-bottom: 40px !important;
  }

  .pb40 {
    padding-bottom: 40px !important;
  }

  .txtButton {
    font-size: 13px;
  }

  span {
    font-size: 10px;
  }

  .titlePaypal,
  .titleModal {
    font-size: 14px;
  }

  .dropDownBanner {
    left: 0 !important;
    right: auto !important;
  }

  .card {
    padding: 35px 40px;
  }

  .alignLeft,
  .alignCenter,
  .cardCenter {
    left: 50% !important;
    transform: translateX(-50%);
  }
}
</style>
